import {useCallback} from "react";
import {call} from "redux-saga/effects";

import {useSagaCallback} from "../store/sagas";
import {apiPost} from "./client";

export const useDeleteAccount = (feedbackCh) => {
    return useSagaCallback(feedbackCh, useCallback(function* (password) {
        yield call(apiPost, `/api/v2/user/delete`, {
            password
        });
    }, []))
};